import { OptinItemErrorsType } from 'modules/stores/store/content/optin/types/optin-interface'

export const defaultErrors: OptinItemErrorsType = {
  title: '',
  subTitle: '',
  buttonTitle: '',
  'thankYouPage.title': '',
  'thankYouPage.text': '',
}
